export const dashboard = {
  title: "Panel de control intuitivo",
  subtitle:
    "Gestiona todos tus intercambios desde una interfaz simple y moderna",
  features: {
    stats: {
      title: "Estadísticas detalladas",
      description:
        "Sigue tus Noches, intercambios y ahorros realizados en tiempo real",
    },
    notifications: {
      title: "Notificaciones inteligentes",
      description:
        "Recibe alertas de nuevas solicitudes y mensajes importantes",
    },
    management: {
      title: "Gestión simplificada",
      description:
        "Gestiona tus disponibilidades, reservas e intercambios en unos clics",
    },
  },
  cta: "Descubrir el panel de control",
  exchangeConfirmed: "Intercambio confirmado",
  newRequests: "nuevas solicitudes",
  toReview: "A examinar",
};
